const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the Register Directive which defines the sign in form behavior and markup
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app
.filter('capitalizeall', function() {
  return function(input) {
    input = input || '';
    var list = input.split(' ');
    list.forEach(function(item, idx) {
      list[idx] = item.charAt(0).toUpperCase() + item.substr(1).toLowerCase();
    });

    return list.join(' ');
  };
})
.directive('userRegistration', ['Application', '$translate', 'RegistrationData', 'i18n', '$filter', function (Application, $translate, RegistrationData, i18n, $filter) {
  return {
    restrict: 'E',
    template: require('../../../templates/directives/preauth/user-registration.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var sortFn = function(a,b) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        return 0;
      };

      self.translations = {};
      self.code = null;
      self.phase = 1;
      self.countries = [];
      self.retailers = [];
      self.addresses = [];
      var langMap = {
        'en': 'en',
        'ar': 'ar',
        'zh_cn': 'zh_CN',
        'zh_tw': 'zh_TW',
        'fr': 'fr',
        'fr_ca': 'fr_CA',
        'de': 'de',
        'hi_in': 'hi_IN',
        'id': 'id',
        'it': 'it',
        'ja': 'ja',
        'ko': 'ko',
        'pl': 'pl',
        'pt_br': 'pt_BR',
        'ru': 'ru',
        'es': 'es_LA',
        'es_la': 'es_LA',
        'es_es': 'es_ES',
        'vi': 'vi',
        'sv_se': 'sv_SE',
        'th': 'th'
      };

      self.host = Application.companyDomain;
      self.canRegister = Application.registerAllow;

      self.userData = {};

      self.submitOnEnter = function(event){
        if(event.keyCode === 13) {
          self.initialSubmit();
        }
      };

      RegistrationData.checkActive({domain: self.host}).$promise
      .then(function(data) {
        if (!data || data.status !== 'active'){
          Application.navigation.goToSignIn();
          return;
        }
      }).catch(function(error) {
        console.log('error: ', error);
        Application.navigation.goToSignIn();
      });

      self.getLanguageFromCode = function(code) {
        var lang = code.split('-')[1];
        if (!lang || !langMap[lang]) {
          return 'en';
        }
        return langMap[lang];
      };

      self.filters = {
        country: {
          visibility: false,
          model: '',
          hasMatches: false,
          itemClick: function (val) {
            self.selectedCountry = $filter('capitalizeall')(val);
            self.selectedRetailer = '';
            self.selectedAddress = '';
            self.filters.country.model = '';
          }
        },
        retailer: {
          visibility: false,
          model: '',
          hasMatches: false,
          itemClick: function (val) {
            self.selectedRetailer = $filter('capitalizeall')(val);
            self.selectedAddress = '';
            self.filters.retailer.model = '';
          }
        },
        address: {
          visibility: false,
          model: '',
          hasMatches: false,
          itemClick: function (item) {
            self.selectedStore = item.value;
            self.selectedAddress = item.name;
            self.filters.address.model = '';
          }
        },
        compare: function(model, val){
          if (!model) {
            return true;
          }
          var regex = new RegExp("^" + model.toLowerCase(), "g");
          return regex.test(val.toLowerCase());
        }
      };

      self.findNext = function(set, value) {
        for (var i = 0; i < set.length; i++) {
          if (set[i].value === value) {
            return set[i].next;
          }
        }
        return [];
      };

      self.allowSecondSubmit = function() {
        return (self.userData.first_name && self.userData.last_name && self.userData.email && self.selectedCountry && self.selectedRetailer && self.selectedStore && self.userData.password && self.passwordConfirm) || false;
      };

      var langCode;
      self.initialSubmit = function() {
        self.loading = true;
        if (!self.code) {
          return;
        }
        var lcCode = self.code.toLowerCase();
        langCode = self.getLanguageFromCode(lcCode);
        RegistrationData.initialSubmit({code: lcCode, domain: self.host}).$promise
        .then(function(results) {
          self.selectionData = results;
          self.phase = 2;
          self.userData.language_code = langCode;
          self.countries = results.countries.map(function(item) {
            return {
              name: item.country,
              value: item.country,
              next: item.retailers || []
            }
          }).sort(sortFn);
          i18n.language(langCode);
          setTimeout(function() {
            $translate([
              'user.registration.success',
              'user.registration.error',
              'user.registration.invalid'
            ]).then(function(translations) {
              self.translations = translations;
            });
          }, 1000);
          self.loading = false;
        }).catch(function(error) {
          console.log('error: ', error)
          Application.messaging.addMessage({type: 'error', duration: 7, text: self.translations['user.registration.invalid']})
          self.loading = false;
        });
      };

      self.submitUser = function() {
        if (self.regForm.email.$invalid) {
          Application.messaging.addMessage({type: 'error', text: 'Invalid Email Address', duration: 5});
          return;
        }
        if (self.userData.password !== self.passwordConfirm) {
          Application.messaging.addMessage({type: 'error', text: "Passwords don't match", duration: 5});
          return;
        }
        self.loading = true;
        var user = Object.assign({
          country: self.selectedCountry,
          retailer: self.selectedRetailer
        }, self.selectedStore);
        user = Object.assign(user, self.userData);
        user.language_code = langMap[user.language_code.toLowerCase()] || langCode;
        RegistrationData.secondSubmit({domain: self.host, user: user}).$promise
        .then(function(results) {
          if (results && results.status && results.status === 'success') {
            Application.messaging.addMessage({type: 'success', duration: 7, text: self.translations['user.registration.success']})
            Application.navigation.goToSignIn();
          }
          self.loading = false;
        }).catch(function(error) {
          console.log('error: ', error)
          Application.messaging.addMessage({type: 'error', duration: 7, text: self.translations['user.registration.error']})
          self.loading = false;
        })
      };

      $translate([
        'user.registration.success',
        'user.registration.error',
        'user.registration.invalid'
      ]).then(function(translations) {
        self.translations = translations;
      });

      $scope.$watch('register.selectedCountry', function(newVal, oldVal) {
        if (!newVal) {
          self.selectedCountry = null;
          self.selectedAddress = null;
          self.selectedRetailer = null;
          self.selectedStore = null;
          self.addresses = [];
          self.retailers = [];
          return;
        }
        self.retailers = self.findNext(self.countries, newVal.toLowerCase()).map(function(item) {
          return {
            name: item.retailer,
            value: item.retailer,
            next: item.stores || []
          }
        }).sort(sortFn);
      });

      $scope.$watch('register.selectedRetailer', function(newVal, oldVal) {
        if (!newVal) {
          self.selectedAddress = null;
          self.selectedRetailer = null;
          self.selectedStore = null;
          self.addresses = [];
          return;
        }
        self.addresses = self.findNext(self.retailers, newVal.toLowerCase()).map(function(item) {
          return {
            name: item.store_address,
            value: item
          }
        }).sort(sortFn);
      });

      $scope.$watch('register.selectedAddress', function(newVal, oldVal) {
        if (!newVal) {
          self.selectedAddress = null;
          self.selectedStore = null;
          return;
        }
      });

    }],
    controllerAs: 'register'
  };
}]);